import { useEffect, useState } from 'react';

/**
 * The team's repositories as the server has them on disk: which branch each
 * checkout is on and when its last commit landed. Read-only -- cloning and
 * pulling are the server's job, not a button.
 *
 * Lives as a tab of the settings dialog, which owns the scrim, Escape and
 * the close button.
 */

interface Repo {
  slug: string;
  present: boolean;
  defaultBranch: string;
  head?: string;
  lastCommitAt?: number;
}

const dateFormat = new Intl.DateTimeFormat(undefined, {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function ReposPanel() {
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(true);
  const [repos, setRepos] = useState<Repo[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetch('/api/repos', { credentials: 'same-origin' })
      .then(async (res) => {
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.message || body.error || `Request failed (${res.status})`);
        return body;
      })
      .then((body) => {
        if (cancelled) return;
        setAvailable(body.available !== false);
        setRepos(body.repos ?? []);
      })
      .catch((e: Error) => !cancelled && setError(e.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="share__head settings__head">
        <div>
          <div className="share__title">Repolar</div>
          <div className="share__sub">Sunucuda tutulan checkout'lar ve bulundukları branch.</div>
        </div>
      </div>

      <div className="gitkey__body">
        {loading && <p className="share__empty">Yükleniyor…</p>}
        {error && <p className="gitkey__error">{error}</p>}
        {!loading && !error && !available && (
          <p className="gitkey__warn">Sunucuda repo servisi çalışmıyor.</p>
        )}
        {!loading && !error && available && repos.length === 0 && (
          <p className="share__empty">Tanımlı repo yok.</p>
        )}

        {repos.length > 0 && (
          <table className="repos__table">
            <thead>
              <tr>
                <th>Repo adı</th>
                <th>Branch</th>
                <th>Son güncelleme</th>
              </tr>
            </thead>
            <tbody>
              {repos.map((r) => (
                <tr key={r.slug}>
                  <td className="repos__slug">{r.slug}</td>
                  <td>
                    {r.present ? (
                      <code>{r.head ?? r.defaultBranch}</code>
                    ) : (
                      <span className="repos__muted">henüz klonlanmadı</span>
                    )}
                  </td>
                  <td className="repos__date">
                    {r.lastCommitAt ? dateFormat.format(r.lastCommitAt) : <span className="repos__muted">—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
